module.exports = __webpack_public_path__ + "img/item-byod.9e687b0a.png";